// pages/Dashboard.js
import React, { useEffect, useState } from "react";
import { Row, Col, Button, Tabs, Tab, Form } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import { CalendarCheck, CheckCircle, Clock, ArrowClockwise } from "react-bootstrap-icons";

import StatsCard from "../../components/dashboard/StatsCard";
import DriverActivity from "../../components/dashboard/DriverActivity";
import EntryExitActivity from "../../components/dashboard/EntryExitActivity";
import { Loader } from "../../components/common/Loader";
import { bookingsAnalyticsApi } from "../../services/Networkcall";
import { errorAlert } from "../../components/common/Alert";
import BookingHistory from "../../components/dashboard/BookingHistory";

const Dashboard = () => {
    const [key, setKey] = useState("booking");
    const [dateRange, setDateRange] = useState([new Date(), new Date()]);
    const [startDate, endDate] = dateRange;
    const [anylticsData, setAnalyticsData] = useState(null);
    const [loading, setLoading] = useState(false);

    const fetchAnalyticsData = async () => {
        setLoading(true);
        try {
            const res = await bookingsAnalyticsApi();
            if (res?.success) {
                setAnalyticsData(res?.data);
            }
            else {
                errorAlert({ message: res?.message || "Failed to fetch analytics data" })
            }
        } catch (err) {
            errorAlert({message: err?.response?.data?.message || err?.message || "Failed to fetch analytics data" })
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        fetchAnalyticsData();
    }, [])

    return (
        <div className="d-flex">
            <Loader show={loading} />
            <div className="flex-grow-1 p-4 vh-100 overflow-auto">

                {/* 🔥 Header */}
                <div className="d-flex justify-content-between align-items-center">
                    <h3 className="mb-0">Dashboard</h3>
                    {/* 
                    <div className="d-flex gap-2 align-items-center">

                        {/* 📅 Date Range  
                        <div className="date-picker-wrapper">
                            <DatePicker
                                selectsRange
                                startDate={startDate}
                                endDate={endDate}
                                onChange={(update) => setDateRange(update)}
                                className="form-control"
                                dateFormat="MM/dd/yyyy"
                            />
                        </div>

                        {/* ⚙️ Filter Button  
                        <Button variant="light" className="border">
                            Filters
                        </Button>
                    </div> */}
                </div>

                {/* 🔥 Tabs */}
                <Tabs
                    activeKey={key}
                    onSelect={(k) => setKey(k)}
                    className="mt-3 dashboard-tabs"
                >
                    <Tab eventKey="booking" title="Booking History" />
                    <Tab eventKey="driver" title="Driver Activity" />
                    <Tab eventKey="entry" title="Entry & Exit Activity" />
                </Tabs>

                {/* 🔥 Stats */}
                <Row className="my-3 g-2">
                    <Col xs={6} sm={6} md={3}><StatsCard
                        title="Total Bookings"
                        value={anylticsData?.total || 0}
                        color="#1976d2"
                        bgColor="#e3f2fd"
                        icon={CalendarCheck}
                    /></Col>

                    <Col xs={6} sm={6} md={3}><StatsCard
                        title="Completed"
                       value={anylticsData?.completed || 0}
                        color="#2e7d32"
                        bgColor="#e8f5e9"
                        icon={CheckCircle}
                    /></Col>

                     <Col xs={6} sm={6} md={3}><StatsCard
                        title="Ongoing"
                        value={anylticsData?.ongoing || 0}
                        color="#ff8400"
                        bgColor="#fdf0da"
                        icon={ArrowClockwise}
                    /></Col>

                    <Col xs={6} sm={6} md={3}><StatsCard
                        title="Upcoming"
                        value={anylticsData?.upcoming || 0}
                        color="#f9a825"
                        bgColor="#fff8e1"
                        icon={Clock}
                    /></Col>

                   
                </Row>

                {/* 🔥 Dynamic Content Based on Tab */}
                {key === "booking" && <BookingHistory />}
                {key === "driver" && <DriverActivity activityKey={key} />}
                {key === "entry" && <EntryExitActivity activityKey={key} />}

                {/* 🔥 Bottom Section (optional remove if using tabs fully) */}
                {key === "booking" && (
                    <Row className="mt-4 g-2">
                        <Col md={6}><DriverActivity activityKey={key} /></Col>
                        <Col md={6}><EntryExitActivity activityKey={key} /></Col>
                    </Row>
                )}
            </div>
        </div>
    );
};

export default Dashboard;